import { useReducer } from 'react';

const useSetState = <State>(initialState: State) =>
  useReducer(
    (state: State, newState: Partial<State>) => ({
      ...state,
      ...newState,
    }),
    initialState
  );

export default useSetState;
